import React, { FC } from 'react';
import { CodeTabSectionProps } from '../../../types';
import { NO_SECTION } from './constants';

export interface CodeTabProps {
  sections: FC<CodeTabSectionProps>[];
  expandedSectionIndex: number;
  onExpandToggle: (sectionIndex: number) => void,
}

export const CodeTab: FC<CodeTabProps> = ({ sections, expandedSectionIndex, onExpandToggle }) => {
  const someSectionIsExpanded = expandedSectionIndex !== NO_SECTION;

  return (
    <>
      {sections.map((Section, index) => (
        <div hidden={someSectionIsExpanded && expandedSectionIndex !== index} key={index}>
          <Section isExpanded={expandedSectionIndex === index} onExpandToggle={() => onExpandToggle(index)} data-test={`code-tab-section-${index}`} />
        </div>
      ))}
    </>
  );
};
